(() => {
  Drupal.behaviors.setScrollbarWidth = {
    attach: function(context, settings) {
      const width = window.innerWidth - document.documentElement.clientWidth;
      const root = document.documentElement;
      root.style.setProperty('--scrollbar-width', `${width}px`);
      document.documentElement.classList.add('has-scrollbar-width-set');
    },
  };
})();
